// extracted by mini-css-extract-plugin
export default {"database":"Common_database__xAkR2","success-snackbar":"Common_success-snackbar__+DwE8"};